import { DropdownChangeEvent } from 'primeng/dropdown';
import {
  EoFormControlConfig,
  IEoFormControlConfig,
} from '../eo-form/eo-form.config';
import { styleProperties } from '../../table/model/common-models/style.model';

export interface IEoPicklistConfig<T> extends IEoFormControlConfig {
  type?: 'picklist';
  sourceData?: T[];
  optionLabel?: string;
  optionValue?: string;
  options?: T[];
  dropdownStyleClass?: string;
  placeholder?: string;
  loadingPlaceholder?: string;
  filter?: boolean;
  filterBy?: string;
  filterFields?: any[];
  filterPlaceholder?: string;
  apiUrl?: string;
  group?: boolean;
  onChange?: (value: DropdownChangeEvent) => void;
  target?: T[];
  sourceHeader?: string;
  targetHeader?: string;
  dragdrop?: boolean;
  responsive?: boolean;
  sourceStyle?: styleProperties;
  targetStyle?: styleProperties;
  sourceFilterPlaceholder?: string;
  targetFilterPlaceholder?: string;
}

export class EoPicklistConfig<T>
  extends EoFormControlConfig
  implements IEoPicklistConfig<T>
{
  override type?: 'picklist';
  sourceData?: T[];
  optionLabel?: string;
  optionValue?: string;
  options?: T[];
  dropdownStyleClass?: string;
  placeholder?: string;
  loadingPlaceholder?: string;
  filter?: boolean;
  filterBy?: string;
  filterFields?: any[];
  filterPlaceholder?: string;
  apiUrl?: string;
  group?: boolean;
  override onChange?: (value: DropdownChangeEvent) => void;
  target?: T[];
  sourceHeader?: string;
  targetHeader?: string;
  dragdrop?: boolean;
  responsive?: boolean;
  sourceStyle?: styleProperties;
  targetStyle?: styleProperties;
  sourceFilterPlaceholder?: string;
  targetFilterPlaceholder?: string;

  constructor();
  constructor(obj: IEoPicklistConfig<T>);
  constructor(obj?: IEoPicklistConfig<T>) {
    super(obj as IEoFormControlConfig);
    
    this.type = 'picklist';
    this.optionLabel = obj?.optionLabel;
    this.optionValue = obj?.optionValue;
    this.options = obj?.options;
    this.dropdownStyleClass = obj?.dropdownStyleClass;
    this.placeholder = obj?.placeholder;
    this.loadingPlaceholder = obj?.loadingPlaceholder;
    this.filter = obj?.filter;
    this.filterBy = obj?.filterBy;
    this.filterFields = obj?.filterFields;
    this.filterPlaceholder = obj?.filterPlaceholder;
    this.apiUrl = obj?.apiUrl;
    this.group = obj?.group;
    this.target = obj?.target ?? [];
    this.sourceHeader = obj?.sourceHeader;
    this.targetHeader = obj?.targetHeader;
    this.dragdrop = obj?.dragdrop ?? true;
    this.responsive = obj?.responsive ?? true;
    this.sourceStyle = obj?.sourceStyle ?? { height: '10rem' };
    this.targetStyle = obj?.targetStyle ?? { height: '10rem' };
    this.sourceFilterPlaceholder = obj?.sourceFilterPlaceholder;
    this.targetFilterPlaceholder = obj?.targetFilterPlaceholder;
    this.sourceData = obj?.sourceData ?? [];
  }
}
